import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Button, Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import "../../../assets/css/tv-shows-height-fix.css";
import axios from "axios";
import { TMDB_CONFIG, getImageUrl, getPosterUrl } from "../../../config/tmdb";
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";
import banner1 from "../../../assets/images/shows-banner/show-1.jpg";
import banner2 from "../../../assets/images/shows-banner/show-2.jpg";
import banner3 from "../../../assets/images/shows-banner/show-3.jpg";

import {
  popularshows,
  tvshows,
  BestInternationalShows,
  Recommend,
  contentDetail,
} from "../dummyData/categoryDummyData";
import { toast } from "react-toastify";


SwiperCore.use([Navigation]);

// TMDB TV Shows Popular API Service
const fetchPopularTVShows = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}/tv/popular?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB popular TV shows:', error);
    throw error;
  }
};

// TMDB On The Air TV Shows API Service
const fetchOnTheAirTVShows = async () => {
  try {
    // Prefer configured JWT, fallback to provided token if not configured
    const fallbackToken = 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI';
    const bearer = (TMDB_CONFIG && TMDB_CONFIG.JWT_TOKEN && TMDB_CONFIG.JWT_TOKEN !== 'YOUR_TMDB_JWT_TOKEN')
      ? TMDB_CONFIG.JWT_TOKEN
      : fallbackToken;

    const url = `${TMDB_CONFIG.BASE_URL}/tv/on_the_air?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${bearer}`
      }
    };
    
    const response = await axios.request(options);
    console.log('TMDB on_the_air raw response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB on the air TV shows:', error);
    throw error;
  }
};

// TMDB Airing Today TV Shows API Service
const fetchAiringTodayTVShows = async () => {
  try {
    // Prefer configured JWT, fallback to provided token if not configured
    const fallbackToken = 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI';
    const bearer = (TMDB_CONFIG && TMDB_CONFIG.JWT_TOKEN && TMDB_CONFIG.JWT_TOKEN !== 'YOUR_TMDB_JWT_TOKEN')
      ? TMDB_CONFIG.JWT_TOKEN
      : fallbackToken;

    const url = `${TMDB_CONFIG.BASE_URL}/tv/airing_today?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${bearer}`
      }
    };
    
    const response = await axios.request(options);
    console.log('TMDB airing_today raw response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB airing today TV shows:', error);
    throw error;
  }
};

// TMDB TV Shows Top Rated API Service
const fetchTopRatedTVShows = async () => {
  try {
    // Check if JWT token is configured
    if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
      throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
    }

    const url = `${TMDB_CONFIG.BASE_URL}/tv/top_rated?language=en-US&page=1`;

    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB top-rated TV shows:', error);
    throw error;
  }
};

// TMDB Season Details API Service
const fetchSeasonDetails = async (seriesId, seasonNumber) => {
  try {
    const url = `${TMDB_CONFIG.BASE_URL}/tv/${seriesId}/season/${seasonNumber}?language=en-US`;
    
    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('Error fetching TMDB season details:', error);
    throw error;
  }
};

// TMDB Season Episodes API Service - Get episodes of a specific season
const fetchSeasonEpisodes = async (seriesId, seasonNumber) => {
  try {
    const url = `${TMDB_CONFIG.BASE_URL}/tv/${seriesId}/season/${seasonNumber}?language=en-US`;
    
    const options = {
      method: 'GET',
      url: url,
      headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
      }
    };
    
    const response = await axios.request(options);
    
    // Extract episodes data
    const episodesData = response.data.episodes || [];
    
    console.log(`Episodes in season ${seasonNumber}:`, episodesData);
    
    return {
      seasonInfo: {
        id: response.data.id,
        name: response.data.name,
        overview: response.data.overview,
        seasonNumber: response.data.season_number,
        episodeCount: response.data.episode_count,
        airDate: response.data.air_date
      },
      episodes: episodesData.map(episode => ({
        id: episode.id,
        name: episode.name,
        overview: episode.overview,
        episodeNumber: episode.episode_number,
        airDate: episode.air_date,
        stillPath: getPosterUrl(episode.still_path),
        voteAverage: episode.vote_average,
        voteCount: episode.vote_count,
        runtime: episode.runtime,
        crew: episode.crew || [],
        guestStars: episode.guest_stars || []
      }))
    };
  } catch (error) {
    console.error('Error fetching TMDB season episodes:', error);
    throw error;
  }
};

// Transform TMDB TV shows data to match component structure
const transformTMDBTVShowData = (tmdbShows, seasonDetailsData = {}) => {
  return tmdbShows.results.map(show => {
    // Get season info if available
    const seasonInfo = seasonDetailsData[show.id];
    const actualSeasons = seasonInfo ? `${seasonInfo.season_number || 1} Season${(seasonInfo.season_number || 1) > 1 ? 's' : ''}` : 'Multiple Seasons';
    
    return {
      _id: show.id.toString(),
      title: show.name,
      contentName: show.name,
      description: show.overview,
      thumbnail_image: getImageUrl(show.backdrop_path),
      poster_image: getPosterUrl(show.poster_path),
      first_air_date: show.first_air_date,
      vote_average: show.vote_average,
      vote_count: show.vote_count,
      adult: show.adult,
      genre_ids: show.genre_ids,
      original_language: show.original_language,
      original_name: show.original_name,
      popularity: show.popularity,
      // Add default values for fields that might not exist in TMDB
      ageLimit: show.adult ? '18+' : '13+',
      seasons: actualSeasons,
      likes: Math.floor(Math.random() * 50) + 10, // Random likes for demo
      seasonEpisodeCount: seasonInfo ? seasonInfo.episode_count : null,
      seasonName: seasonInfo ? seasonInfo.name : null,
      seasonOverview: seasonInfo ? seasonInfo.overview : null,
      seasonId: show.id, // Store series ID for fetching season details
    };
  });
};

const CategoryList = () => {
  
  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000, 
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url)
   
  };

  const addToWatchlist = (movie) => {
    const watchlist = JSON.parse(localStorage.getItem("watchlist")) || [];
    watchlist.push(movie);
    localStorage.setItem("watchlist", JSON.stringify(watchlist));
  };

  // Handle season details click
  const handleSeasonDetailsClick = async (seriesId, seasonNumber = 1) => {
    try {
      const seasonData = await fetchSeasonDetailsForShow(seriesId, seasonNumber);
      console.log('Season details:', seasonData);
      
      // Show toast notification with season details
      toast.success(`Season ${seasonNumber} Details Loaded: ${seasonData.name}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      
      return seasonData;
    } catch (error) {
      console.error('Error fetching season details:', error);
      toast.error('Failed to load season details', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // Handle season episodes click
  const handleSeasonEpisodesClick = async (seriesId, seasonNumber = 1) => {
    try {
      const episodesData = await fetchSeasonEpisodesForShow(seriesId, seasonNumber);
      console.log('Season episodes:', episodesData);
      
      // Show toast notification with episodes information
      toast.success(`Season ${seasonNumber} Episodes Loaded: ${episodesData.seasonInfo.name} (${episodesData.episodes.length} episodes)`, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      
      // Log episode details in console for easy access
      console.table(episodesData.episodes.map((episode, index) => ({
        '#': index + 1,
        'Name': episode.name,
        'Episode': episode.episodeNumber,
        'Air Date': episode.airDate,
        'Runtime': episode.runtime + ' min',
        'Rating': episode.voteAverage?.toFixed(1) || 'N/A'
      })));
      
      return episodesData;
    } catch (error) {
      console.error('Error fetching season episodes:', error);
      toast.error('Failed to load season episodes', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleLinkClick = () => {
    window.scrollTo(0, 0); 
  };

  // TMDB TV Shows state management
  const [tmdbTVShows, setTmdbTVShows] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // TMDB Top Rated TV Shows state management
  const [tmdbTopRatedTVShows, setTmdbTopRatedTVShows] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // TMDB Popular TV Shows for Popular Section state management
  const [tmdbPopularTVShowsSection, setTmdbPopularTVShowsSection] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // Season details state management
  const [seasonDetails, setSeasonDetails] = useState({
    data: {},
    loading: false,
    error: null
  });

  // Season episodes state management
  const [seasonEpisodes, setSeasonEpisodes] = useState({
    data: {},
    loading: false,
    error: null
  });

  // TMDB Best International Shows (on_the_air) state
  const [tmdbInternationalShows, setTmdbInternationalShows] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // TMDB Shows We Recommend (airing_today) state
  const [tmdbAiringTodayShows, setTmdbAiringTodayShows] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // Fetch TMDB popular TV shows
  const fetchTMDBPopularTVShows = async () => {
    setTmdbTVShows(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchPopularTVShows();
      const transformedData = transformTMDBTVShowData(data);
      setTmdbTVShows({
        shows: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Popular TV Shows fetched:", transformedData);
    } catch (error) {
      setTmdbTVShows(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB popular TV shows:", error);
    }
  };

  // Fetch TMDB top-rated TV shows
  const fetchTMDBTopRatedTVShows = async () => {
    setTmdbTopRatedTVShows(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchTopRatedTVShows();
      const transformedData = transformTMDBTVShowData(data);
      setTmdbTopRatedTVShows({
        shows: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Top Rated TV Shows fetched:", transformedData);
    } catch (error) {
      setTmdbTopRatedTVShows(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB top-rated TV shows:", error);
    }
  };

  // Fetch TMDB popular TV shows for Popular Section
  const fetchTMDBPopularTVShowsSection = async () => {
    setTmdbPopularTVShowsSection(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchPopularTVShows();
      const transformedData = transformTMDBTVShowData(data);
      setTmdbPopularTVShowsSection({
        shows: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Popular TV Shows Section fetched:", transformedData);
    } catch (error) {
      setTmdbPopularTVShowsSection(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB popular TV shows section:", error);
    }
  };

  // Fetch TMDB On The Air TV Shows for Best International Shows section
  const fetchTMDBInternationalShows = async () => {
    setTmdbInternationalShows(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchOnTheAirTVShows();
      const transformedData = transformTMDBTVShowData(data);
      setTmdbInternationalShows({
        shows: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB On The Air (International) fetched:", transformedData);
    } catch (error) {
      setTmdbInternationalShows(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB On The Air (International):", error);
    }
  };

  // Fetch TMDB Airing Today for Shows We Recommend section
  const fetchTMDBAiringTodayShows = async () => {
    setTmdbAiringTodayShows(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchAiringTodayTVShows();
      const transformedData = transformTMDBTVShowData(data);
      setTmdbAiringTodayShows({
        shows: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Airing Today (Recommend) fetched:", transformedData);
    } catch (error) {
      setTmdbAiringTodayShows(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error("Failed to fetch TMDB Airing Today (Recommend):", error);
    }
  };

  // Fetch season details for a TV show
  const fetchSeasonDetailsForShow = async (seriesId, seasonNumber = 1) => {
    setSeasonDetails(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchSeasonDetails(seriesId, seasonNumber);
      setSeasonDetails(prev => ({
        ...prev,
        data: { ...prev.data, [seriesId]: data },
        loading: false,
        error: null
      }));
      console.log(`Season ${seasonNumber} details for series ${seriesId} fetched:`, data);
      return data;
    } catch (error) {
      setSeasonDetails(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error(`Failed to fetch season details for series ${seriesId}:`, error);
      throw error;
    }
  };

  // Fetch season episodes for a TV show
  const fetchSeasonEpisodesForShow = async (seriesId, seasonNumber = 1) => {
    setSeasonEpisodes(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchSeasonEpisodes(seriesId, seasonNumber);
      setSeasonEpisodes(prev => ({
        ...prev,
        data: { ...prev.data, [`${seriesId}_${seasonNumber}`]: data },
        loading: false,
        error: null
      }));
      console.log(`Season ${seasonNumber} episodes for series ${seriesId} fetched:`, data);
      return data;
    } catch (error) {
      setSeasonEpisodes(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      console.error(`Failed to fetch season episodes for series ${seriesId}:`, error);
      throw error;
    }
  };

  useEffect(() => {
    fetchTMDBPopularTVShows();
    fetchTMDBTopRatedTVShows();
    fetchTMDBPopularTVShowsSection();
    fetchTMDBInternationalShows();
    fetchTMDBAiringTodayShows();
  }, []);
  
  return (
    <>
      <section id="tvshow" className="iq-main-slider p-0">
        <div id="prev" className="swiper-button swiper-button-prev">
          <i className="ri-arrow-left-s-line"></i>
        </div>
        <div id="next" className="swiper-button swiper-button-next">
          <i className="ri-arrow-right-s-line"></i>
        </div>
        <Swiper
          slidesPerView={2}
          navigation={{
            prevEl: "#prev",
            nextEl: "#next",
          }}
          loop={true}
          centeredSlides={true}
          id="tvshows-slider"
          className="iq-rtl-direction"
        >
          {tmdbTVShows.loading ? (
            <div className="tv-shows-loading">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
                  </div>
                </div>
          ) : tmdbTVShows.error ? (
            <div className="tv-shows-error">
              <div className="text-center">
                <h3>Error Loading TV Shows</h3>
                <p>{tmdbTVShows.error}</p>
                <button 
                  className="btn btn-primary mt-3" 
                  onClick={fetchTMDBPopularTVShows}
                >
                  Retry
                </button>
              </div>
            </div>
          ) : tmdbTVShows.shows && tmdbTVShows.shows.length > 0 ? (
            tmdbTVShows.shows.slice(0, 6).map((show, index) => (
              <SwiperSlide key={show._id || index}>
                <Link to={`/show-details/${show._id}`}>
              <div className="shows-img">
                    <img 
                      src={show.thumbnail_image || 'https://via.placeholder.com/800x400/333/fff?text=No+Image'} 
                      className="w-100" 
                      alt={show.title}
                    />
                <div className="shows-content">
                      <h4 className="text-white mb-1">{show.title}</h4>
                  <div className="movie-time d-flex align-items-center">
                        <div className="badge badge-secondary p-1 mr-2">{show.ageLimit}</div>
                        <span className="text-white">{show.seasons}</span>
                  </div>
                </div>
              </div>
            </Link>
          </SwiperSlide>
            ))
          ) : (
            <div className="tv-shows-error">
              <div className="text-center">
                <h3>No TV Shows Available</h3>
                <p>Please check back later for new shows.</p>
                  </div>
                </div>
          )}
        </Swiper>
        <Dropdown className="genres-box">
          <Dropdown.Toggle as={Button} variant="secondary" className="">
            Genres
          </Dropdown.Toggle>
          <Dropdown.Menu className="three-column">
            <Dropdown.Item href="#">Hindi</Dropdown.Item>
            <Dropdown.Item href="#">Tamil</Dropdown.Item>
            <Dropdown.Item href="#">Punjabi</Dropdown.Item>
            <Dropdown.Item href="#">English</Dropdown.Item>
            <Dropdown.Item href="#">Comedies</Dropdown.Item>
            <Dropdown.Item href="#">Action</Dropdown.Item>
            <Dropdown.Item href="#">Romance</Dropdown.Item>
            <Dropdown.Item href="#">Dramas</Dropdown.Item>
            <Dropdown.Item href="#">Bollywood</Dropdown.Item>
            <Dropdown.Item href="#">Hollywood</Dropdown.Item>
            <Dropdown.Item href="#">Children & Family</Dropdown.Item>
            <Dropdown.Item href="#">Award-Winning</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </section>
      <div className="main-content">
        <section id="iq-favorites-trending">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Top Rated TV Shows</h4>
                  <Link className="iq-view-all" to="/view-all"  onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div id="prev1" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next1" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      prevEl: "#prev1",
                      nextEl: "#next1",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbTopRatedTVShows.loading ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : tmdbTopRatedTVShows.error ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">Error Loading TV Shows</h3>
                          <p className="text-white-50">{tmdbTopRatedTVShows.error}</p>
                          <button 
                            className="btn btn-primary mt-3" 
                            onClick={fetchTMDBTopRatedTVShows}
                          >
                            Retry
                          </button>
                        </div>
                      </div>
                    ) : tmdbTopRatedTVShows.shows && tmdbTopRatedTVShows.shows.length > 0 ? (
                      tmdbTopRatedTVShows.shows.slice(0, 8).map((show, index) => (
                        <SwiperSlide key={show._id || index} className="slide-item">
                        <div className="block-images1 block-images position-relative">
                          <div className="img-box">
                            <img
                                src={show.poster_image || 'https://via.placeholder.com/300x450/333/fff?text=No+Image'}
                              className="img-fluid"
                                alt={show.title}
                                style={{
                                  width: '100%',
                                  height: '200px',
                                  objectFit: 'cover'
                                }}
                            />
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                                <Link to={`/show-details/${show._id}`}>{show.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2">
                              <div className="badge badge-secondary p-1 mr-2">
                                  {show.ageLimit}
                              </div>
                                <span className="text-white">{show.seasons}</span>
                              </div>
                              <div className="category-page">
                                <div className="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3">
                                  <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                                  </ul>
                                  <span className="text-white ml-2">
                                    {show.vote_average ? show.vote_average.toFixed(1) : 'N/A'}(TMDB)
                                  </span>
                                </div>
                            </div>
                            <div className="hover-buttons">
                              <Link
                                  to={`/show-details/${show._id}`}
                                role="button"
                                className="btn btn-hover"
                              >
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
                                <span>
                                  <i className="ri-share-fill"></i>
                                </span>
                                <div className="share-box">
                                  <div className="d-flex align-items-center">
                                    <a
                                            href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-facebook-fill"></i>
                                    </a>
                                    <a
                                      href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                      href="#"
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                              <CompactWatchlistButtons item={{
                                id: parseInt(show._id),
                                title: show.title,
                                type: 'tv',
                                poster_path: show.poster_image?.includes('tmdb.org') ? show.poster_image.split('/').pop() : null,
                                imgSrc: show.poster_image,
                                vote_average: show.vote_average,
                                release_date: show.first_air_date || show.release_date,
                                overview: show.overview,
                                adult: show.adult
                              }} />
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                      ))
                    ) : (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">No TV Shows Available</h3>
                          <p className="text-white-50">Please check back later for new shows.</p>
                        </div>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="iq-favorites-tv-popular">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">TV Popular Shows</h4>
                  <Link className="iq-view-all" to="/view-all"  onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div id="prev2" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next2" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      prevEl: "#prev2",
                      nextEl: "#next2",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbPopularTVShowsSection.loading ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : tmdbPopularTVShowsSection.error ? (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">Error Loading TV Shows</h3>
                          <p className="text-white-50">{tmdbPopularTVShowsSection.error}</p>
                          <button 
                            className="btn btn-primary mt-3" 
                            onClick={fetchTMDBPopularTVShowsSection}
                          >
                            Retry
                          </button>
                        </div>
                      </div>
                    ) : tmdbPopularTVShowsSection.shows && tmdbPopularTVShowsSection.shows.length > 0 ? (
                      tmdbPopularTVShowsSection.shows.slice(0, 8).map((show, index) => (
                        <SwiperSlide key={show._id || index} className="slide-item">
                        <div className="block-images1 block-images position-relative">
                          <div className="img-box">
                            <img
                                src={show.poster_image || 'https://via.placeholder.com/300x450/333/fff?text=No+Image'}
                              className="img-fluid"
                                alt={show.title}
                                style={{
                                  width: '100%',
                                  height: '200px',
                                  objectFit: 'cover'
                                }}
                            />
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                                <Link to={`/show-details/${show._id}`}>{show.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2">
                              <div className="badge badge-secondary p-1 mr-2">
                                  {show.ageLimit}
                              </div>
                                <span className="text-white">{show.seasons}</span>
                              </div>
                              <div className="category-page">
                                <div className="slider-ratting d-flex align-items-center mr-4 mt-2 mt-md-3">
                                  <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                    <li><i className="fa fa-star-half" aria-hidden="true"></i></li>
                                  </ul>
                                  <span className="text-white ml-2">
                                    {show.vote_average ? show.vote_average.toFixed(1) : 'N/A'}(TMDB)
                                  </span>
                                </div>
                            </div>
                            <div className="hover-buttons">
                              <Link
                                  to={`/show-details/${show._id}`}
                                role="button"
                                className="btn btn-hover"
                              >
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
                                <span>
                                  <i className="ri-share-fill"></i>
                                </span>
                                <div className="share-box">
                                  <div className="d-flex align-items-center">
                                    <a
                                            href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-facebook-fill"></i>
                                    </a>
                                    <a
                                      href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                        href="#"
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                              <CompactWatchlistButtons item={{
                                id: parseInt(show._id),
                                title: show.title,
                                type: 'tv',
                                poster_path: show.poster_image?.includes('tmdb.org') ? show.poster_image.split('/').pop() : null,
                                imgSrc: show.poster_image,
                                vote_average: show.vote_average,
                                release_date: show.first_air_date || show.release_date,
                                overview: show.overview,
                                adult: show.adult
                              }} />
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                      ))
                    ) : (
                      <div className="d-flex justify-content-center align-items-center" style={{height: '300px', width: '100%'}}>
                        <div className="text-center">
                          <h3 className="text-white">No TV Shows Available</h3>
                          <p className="text-white-50">Please check back later for new shows.</p>
                        </div>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="iq-favorites-international-shows">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Best of International Shows</h4>
                  <Link className="iq-view-all" to="/view-all"  onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div id="prev3" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>  
                  </div>
                  <div id="next3" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      prevEl: "#prev3",
                      nextEl: "#next3",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbInternationalShows.loading ? (
                      <div className="col-12 text-center d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-3 ml-3">Loading international shows...</p>
                      </div>
                    ) : tmdbInternationalShows.error ? (
                      <div className="col-12 text-center">
                        <h3 className="text-white">Error Loading International Shows</h3>
                        <p className="text-white-50">{tmdbInternationalShows.error}</p>
                        <button 
                          className="btn btn-primary mt-3" 
                          onClick={fetchTMDBInternationalShows}
                        >
                          Retry
                        </button>
                      </div>
                    ) : tmdbInternationalShows.shows && tmdbInternationalShows.shows.length > 0 ? (
                      tmdbInternationalShows.shows.slice(0, 8).map((item, index) => (
                        <SwiperSlide key={item._id || index} className="slide-item">
                        <div className="block-images1 block-images position-relative">
                          <div className="img-box">
                            <img
                                src={item.poster_image}
                              className="img-fluid"
                                style={{ height: '200px', width: '100%', objectFit: 'cover' }}
                                alt={item.title}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/300x450/333/fff?text=No+Image';
                                }}
                            />
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                                <Link to={`/show-details/${item._id}`}>{item.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2">
                              <div className="badge badge-secondary p-1 mr-2">
                                  {item.ageRating || '13+'}
                              </div>
                                <span className="text-white">{item.seasons || 'Multiple Seasons'}</span>
                                {item.vote_average && (
                                  <span className="text-warning ml-2">
                                    ⭐ {item.vote_average.toFixed(1)}
                                  </span>
                                )}
                            </div>
                            <div className="hover-buttons">
                              <Link
                                  to={`/show-details/${item._id}`}
                                role="button"
                                className="btn btn-hover"
                              >
                                <i
                                  className="fa fa-play mr-1"
                                  aria-hidden="true"
                                ></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
                                <span>
                                  <i className="ri-share-fill"></i>
                                </span>
                                <div className="share-box">
                                  <div className="d-flex align-items-center">
                                    <a
                                      href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-facebook-fill"></i>
                                    </a>
                                    <a
                                      href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                    onClick={copyURL}
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                              <CompactWatchlistButtons item={{
                                id: parseInt(item._id),
                                title: item.title,
                                type: 'movie',
                                poster_path: item.poster_image?.includes('tmdb.org') ? item.poster_image.split('/').pop() : null,
                                imgSrc: item.poster_image,
                                vote_average: item.vote_average,
                                release_date: item.release_date,
                                overview: item.overview,
                                adult: item.adult
                              }} />
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No international shows available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="iq-upcoming-movie">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12 overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="main-title">Shows We Recommend</h4>
                  <Link className="iq-view-all" to="/view-all"  onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="upcoming-contens">
                  <div id="prev4" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next4" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    navigation={{
                      nextEl: "#next4",
                      prevEl: "#prev4",
                    }}
                    loop={true}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
                  >
                    {tmdbAiringTodayShows.loading ? (
                      <div className="col-12 text-center d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-3 ml-3">Loading shows airing today...</p>
                      </div>
                    ) : tmdbAiringTodayShows.error ? (
                      <div className="col-12 text-center">
                        <h3 className="text-white">Error Loading Shows</h3>
                        <p className="text-white-50">{tmdbAiringTodayShows.error}</p>
                        <button className="btn btn-primary mt-3" onClick={fetchTMDBAiringTodayShows}>Retry</button>
                      </div>
                    ) : tmdbAiringTodayShows.shows && tmdbAiringTodayShows.shows.length > 0 ? (
                      tmdbAiringTodayShows.shows.slice(0, 8).map((item, index) => (
                        <SwiperSlide key={item._id || index} className="slide-item">
                          <div className="block-images1 block-images position-relative">
                            <div className="img-box">
                              <img
                                src={item.poster_image}
                                className="img-fluid"
                                style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                alt={item.title}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/300x450/333/fff?text=No+Image'; }}
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/show-details/${item._id}`}>{item.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2">
                                <div className="badge badge-secondary p-1 mr-2">{item.ageRating || '13+'}</div>
                                <span className="text-white">Multiple Seasons</span>
                                {item.vote_average && (
                                  <span className="text-warning ml-2">⭐ {item.vote_average.toFixed(1)}</span>
                                )}
                              </div>
                              <div className="hover-buttons">
                                <Link to={`/show-details/${item._id}`} role="button" className="btn btn-hover">
                                  <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/" target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0">
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a href="https://twitter.com/intent/tweet?text=Currentlyreading" target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0">
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a onClick={copyURL} className="share-ico iq-copy-link" tabIndex="0">
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: 'movie',
                                  poster_path: item.poster_image?.includes('tmdb.org') ? item.poster_image.split('/').pop() : null,
                                  imgSrc: item.poster_image,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.overview,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No shows available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </section>
        
      </div>
    </>
  );
};
export default CategoryList;
